(() => {
  const MIN_GALLERY_HEIGHT = 200;

  function getGalleryForForm(form) {
    if (!form?.id) return null;
    return document.querySelector(`product-gallery[form="${CSS.escape(form.id)}"]`);
  }

  function ensureSlideImageLoads(slide) {
    if (!slide) return;
    slide.querySelectorAll('img[loading="lazy"]').forEach((img) => {
      img.removeAttribute("loading");
    });
  }

  function adjustCarouselHeight(carousel) {
    if (!carousel?.hasAttribute("adaptive-height")) return;
    const slide = carousel.selectedSlide || carousel.querySelector(".product-gallery__media.is-selected");
    if (!slide) return;

    const height = slide.clientHeight;
    if (height >= MIN_GALLERY_HEIGHT) {
      carousel.style.maxHeight = `${height}px`;
      return;
    }

    const img = slide.querySelector("img");
    if (!img) return;

    const apply = () => {
      const nextHeight = slide.clientHeight;
      if (nextHeight >= MIN_GALLERY_HEIGHT) {
        carousel.style.maxHeight = `${nextHeight}px`;
      } else {
        carousel.style.removeProperty("max-height");
      }
    };

    if (img.complete && img.naturalWidth > 0) {
      requestAnimationFrame(apply);
      return;
    }

    img.addEventListener("load", apply, { once: true });
  }

  function onVariantChange(event) {
    const form = event.target?.closest?.("form") || event.target;
    const gallery = getGalleryForForm(form);
    if (!gallery) return;

    const featuredMediaId = event.detail?.variant?.featured_media?.id;
    if (featuredMediaId) {
      const slide = gallery.querySelector(`.product-gallery__media[data-media-id="${featuredMediaId}"]`);
      ensureSlideImageLoads(slide);
    }

    gallery.querySelectorAll("media-carousel").forEach((carousel) => {
      ensureSlideImageLoads(carousel.selectedSlide);
      adjustCarouselHeight(carousel);
      requestAnimationFrame(() => adjustCarouselHeight(carousel));
    });
  }

  document.addEventListener("variant:change", onVariantChange);
})();
